// extracted by mini-css-extract-plugin
export default {"webviewStickyFooter":"u8m6MmOpOq4KS2C2cQD5"};